  // Import the functions you need from the SDKs you need
  import { initializeApp } from "firebase/app";
  import { getFirestore } from "firebase/firestore";
  import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


const firebaseConfig = {
  apiKey: "AIzaSyAOufII_OOfy_k25H3ifSoBrVU3PLJLZJM",
  authDomain: "esa3-fe232.firebaseapp.com",
  projectId: "esa3-fe232",
  storageBucket: "esa3-fe232.firebasestorage.app",
  messagingSenderId: "768956841680",
  appId: "1:768956841680:web:523e846f42290bc825a8d5",
  measurementId: "G-TFC5KFC6ZH"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);
export const storage = getStorage(app);
